(ns core.front.event
  (:require [re-frame.core-instrumented :as rf]
            [reagent.ratom :as ratom])
  (:require-macros [core.front.event]))

;; Used by <sub and >evt macros
(defn assert-in-reactive
  "Better warnings when `<sub` is used outside a reactive context.

  At the moment using subscriptions inside e.g. event handlers might leak memory,
  as re-frame will cache the subscription and might never release it. This
  might change in the future (https://github.com/day8/re-frame/issues/753)."
  [query]
  (when ^boolean js/goog.DEBUG
    (when-not (ratom/reactive?)
      (.groupCollapsed js/console (str "Warning: <sub called outside view/subscription: " (pr-str query)))
      (.trace js/console)
      (.groupEnd js/console))))

; Requires `com.7theta/re-frame-fx` lib which implements `:dispatch-debounce` fx.
(rf/reg-event-fx ::input-change
  ;; BROKEN DO NO USE
  ;; you need to specify a unique id per input, otherwise next event
  ;; will override pending update and the event will be lost. Always use
  ;; :dispatch-debounce directly when needed!
  (fn [_ [_ event-vector]]
    {:pre [(vector? event-vector)]}
    {:dispatch-debounce [{:id      ::input-change-event
                          :timeout 500
                          :action  :dispatch
                          :event   event-vector}]}))

(defn add-to-dispatch
  "Add a new dispatch side-effect to a re-frame co-effect return map."
  [{:keys [dispatch dispatch-n] :as fx} also-dispatch]
  (cond-> fx
    (and also-dispatch
         dispatch-n)    (update :dispatch-n conj also-dispatch)
    (and also-dispatch
         dispatch)      (-> (assoc :dispatch-n [dispatch also-dispatch])
                            (dissoc :dispatch))
    (and (nil? dispatch-n)
         (nil? dispatch)
         also-dispatch) (assoc :dispatch also-dispatch)))

(defn- update-cofx
  [state f]
  (let [{db :db fx :fx} (f (:cofx state))]
    (cond-> state
      ;; Collect new fxes, drop duplicates
      (some? fx) (update :fx (comp vec distinct into) fx)
      ;; Update the db coeffect
      (some? db) (assoc-in [:cofx :db] db))))

(defn merge-every-fn
  "Runs `(f cofx)` for each function `f` in `fns` and merges the returned re-frame effects

  Each function should return an effect map, similar to `reg-event-fx`.

  Only `:db` and `:fx` keys are supported."
  [cofx & fns]
  (let [{:keys [cofx fx]} (reduce
                            update-cofx
                            {:cofx cofx}
                            fns)]
    (cond-> {:db (-> cofx :db)}
      (seq fx) (assoc :fx fx))))

(defn merge-every-item
  "Runs `(f cofx item)` for each `item` in `xs` and merges the returned re-frame effects

  The function `f` should return an effect map, similar to `reg-event-fx`.

  Only `:db` and `:fx` keys are supported."
  [cofx f xs]
  (->> xs
       (map (fn [item]
              (fn [cofx] (f cofx item))))
       (apply merge-every-fn cofx)))
